import type { Ref } from 'vue';
import { useState } from 'nuxt/app';
import { Toast, Modal, Dropdown } from 'bootstrap';

type BootstrapSate = {
  modals: { [key: string]: Modal } // modalはインスタンスを保存しておかないとhide()できない
}

export const useBootstrap = () => {
  const state: Ref<BootstrapSate> = useState('BootstrapSate', () => {
    return {
      modals: {}
    };
  });

  return {
    showToast: (id: string)  => {
      const elm = document.getElementById(id);
      if (elm !== null) {
        const toast = new Toast(elm);
        toast.show();
      }
    },
    showModal: (id: string)  => {
      const elm = document.getElementById(id);
      if (elm !== null) {
        const modal = new Modal(elm);
        modal.show();
        state.value.modals[id] = modal;
      }
    },
    hideModal: (id: string)  => {
      if (state.value.modals[id] !== undefined) {
        state.value.modals[id].hide();
        delete state.value.modals[id];
      }
    },
    showDropdown: (id: string)  => {
      const elm = document.getElementById(id);
      if (elm !== null) {
        const dropdown = new Dropdown(elm);
        dropdown.show();
      }
    }
  };
};
